import useTextMaxLength from 'hooks/useTextMaxLength';
import { TooltipPosition } from 'plataforma-fundacao-componentes';

interface Props {
  text: string;
  fontSize: number;
  maxChars: number;
  tooltip?: boolean;
  isTest?: boolean;
}

export default function EllipsisWithTooltip({
  fontSize,
  maxChars,
  text,
  tooltip,
  isTest,
}: Props) {
  const { needTooltip, newText } = useTextMaxLength(
    text,
    fontSize,
    maxChars,
    tooltip
  );

  if (needTooltip && tooltip) {
    return (
      <div
        tooltip-text={text}
        tooltip-position={TooltipPosition.Top}
        style={
          isTest
            ? { color: '#e60000', cursor: 'pointer' }
            : { cursor: 'pointer' }
        }
      >
        <span>{newText}</span>
      </div>
    );
  }

  return <span style={isTest ? { color: '#e60000' } : {}}>{text}</span>;
}
